export default class Header {
  header: any;
  menuLinks: NodeListOf<HTMLElement>;
  mobileMenuLinks: NodeListOf<HTMLElement>;
  mobileMenuToggle: any;
  allMenus: any;

  constructor() {
    this.header = document.querySelector('.header');
    if (!this.header) return;

    this.menuLinks = this.header.querySelectorAll('.header__menu-link--expandable');
    this.allMenus = this.header.querySelectorAll('.menu');
    this.mobileMenuToggle = this.header.querySelector('.header__menu-link--mobile');

    this.init();
    this.initMobile();
    this.initToggle();
    if (this.header.classList.contains('header--reading-progress')) this.initReadingProgress();
  }

  init() {
    this.menuLinks.forEach(link => {

      link.addEventListener('click', (event) => {
        event.preventDefault();
        let id = link.dataset.menu;
        let isActive = link.classList.contains('header__menu-link--active');
        let activeMenuLink = this.header.querySelector('.header__menu-link--active');
        let activeMenu = this.header.querySelector('.menu.menu--active');

        if (activeMenuLink) activeMenuLink.classList.remove('header__menu-link--active')
        if (activeMenu) activeMenu.classList.remove('menu--active')

        if (!isActive) {
          link.classList.add('header__menu-link--active');
          this.header.querySelector('.menu--' + id).classList.add('menu--active');
        }
      });
    });
  }

  initToggle() {
    this.mobileMenuToggle.addEventListener('click', (event) => {
      event.preventDefault();
      this.allMenus.forEach((menu: Element) => {
        menu.classList.toggle('menu--active');
      })
    })
  }

  initMobile() {
    this.allMenus.forEach((menu: Element) => {
      let trigger = menu.querySelector('.menu__mobile-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', (event) => {
        let isActive = menu.classList.contains('menu--active-mobile');
        event.preventDefault();

        this.allMenus.forEach((menu: Element) => menu.classList.remove('menu--active-mobile'));
        if (!isActive) menu.classList.add('menu--active-mobile');
      })
    })
  }

  initReadingProgress() {
    this.readingProgress = this.header.querySelector('.header__progress-indicator');

    document.addEventListener('scroll', (e) => {
      this.updateReadingProgress();
    });

    this.updateReadingProgress();
  }

  updateReadingProgress() {
    let footerHeight = document.querySelector('.footer') ? document.querySelector('.footer').offsetHeight : 0;
    let w = (document.body.scrollTop || document.documentElement.scrollTop) / (document.documentElement.scrollHeight - footerHeight - document.documentElement.clientHeight) * 100;
    this.readingProgress.style.setProperty('width', w + '%');
  }
}
